import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SectionAiSettings from "@/components/SectionAiSettings";

/** Admin Settings -> Documents AI (has its own endpoints; see backend gov_ai_config). */
export default function DocumentsAiSettings() {
  return (
    <SectionAiSettings
      testid="documents-ai-settings"
      title="Documents AI"
      intro="The AI model used by the Documents module."
      privacy="These features send our policy text to the model."
      load={api.govAiSettings}
      save={api.govSaveAiSettings}
      test={api.govTestAiModel}
      footer={<>Search uses a separate embedding model (Cohere Embed English v3), which isn't changed here. The weekly
        email's schedule and wording are in <Link to="/settings/reminders" className="underline">Reminder Emails</Link>.</>}
    />
  );
}
